import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import StudentMatchModal from "./StudentMatchModal";
import OrientationModal from "./OrientationModal";
import ProcessRegistrationModal from "./ProcessRegistrationModal";
import RegistrationContext from "../../context/registration/registrationContext";
import ProgressLevelBar from "./ProgressLevelBar";
import ConfirmModal from "../utilities/ConfirmModal";
import findBrand from "../findBrand";
import { brandDomains, fetchBrands } from "../brand";
import moment from "moment";
import * as FaIcons from "react-icons/fa";
import AddSpecialProgramsModal from "./AddSpecialProgramsModal";
import TerminateEnrollmentModal from "./TerminateEnrollmentModal";
import ExportPdfButton from "./ExportPdfButton";

const RegistrationForm = ({
  formData: {
    _id,
    createdAt,
    status,
    programs,
    programDescription,
    progressLevel,
    processingLevel,
    registerForIntercession,
    previouslyEnrolled,
    firstName,
    middleName,
    lastName,
    haveSuffix,
    suffix,
    gender,
    birthDate,
    age,
    birthState,
    birthCountry,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    pgHighestLevelOfEducation,
    permissionParentContact,
    studentName,
    preferredpronouns,
    pgRelationshipToStudent,
    pgFirstName,
    pgLastName,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    pgPrimaryEmail,
    liveWithPg,
    liveWithPg2,

    livingStatus,
    street,
    city,
    state,
    zip,
    county,
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    mailingCountry,
    isStudentHispanicOrLatino,
    primaryRaceCategory,
    previousSchool,
    previousSchoolCity,
    previousSchoolState,
    primaryLanguage,
    firstLanguage,
    homeLanguage,
    languageSpokenByParentsToStudent,
    languageSpokenByAdultsAtHome,
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities,
    releaseAudioAndVideo,
    releasePermissionForSocialMedia,
    releaseUseStudentWork,
    releasePermissionToTextStudent,
    releasePermissionToTextPg,
    releaseAllowStudentAccessToGoogleAppsForEducation,

    beenExpelled,
    expelledFromWhichSchool,
    expelledWhatYear,
    beenSuspended,
    suspendedFromWhichSchool,
    suspendedWhatYear,
    onProbation,
    isParentOrExpecting,
    moreThanThreeUnexcusedAbsences,
    lateToSchoolMoreThanThreeTimes,
    orderedToAttendSchool,
    orderedToAttendWhichSchool,
    orderedToAttendWhatYear,
    retainedMoreThanOnce,
    retainedFromWhichSchool,
    retainedFromWhatYear,
    droppedOutOfSchool,
    droppedOutFromWhichSchool,
    droppedOutFromWhatYear,
    behindSemesterInCredits,
    outOfSchoolMoreThanFortyFiveDays,
    expelledMoreThanTwoSchoolsPastYear,
    fosterCare,
    gradeLevel,
    youthExperiencingHomelessness,
    accessToComputerAtHome,
    accessToTheInternetAtHome,
    knownHealthConditions,
    asthma,
    beeStingAllergy,
    diabetes,
    epilepsy,

    heartCondition,
    seizures,
    pg2RelationshipToStudent,
    nutAllergy,
    pg2HighestLevelOfEducation,

    knownHearingConditions,
    wearsHearingAid,
    knownEyeCondition,
    glassesToBeWornAtAllTimes,
    wearsContactLenses,
    wearsGlasses,
    medications,
    otherHealthCondition,
    medicalInstructions,
    heathInsuranceCarrier,
    insuranceIdOrPolicyNumber,
    hospitalPreference,
    custodyIssueExists,
    custodyIssueNotes,
    legalRestrictionsForAnyParent,
    legalRestrictionsNotes,
    emergencyContact1FirstName,
    emergencyContact1LastName,
    emergencyContact1Phone,
    pg2PrimaryPhone,
    emergencyContact1Relationship,
    authorizedForPickup1,
    emergencyContact2FirstName,
    emergencyContact2LastName,
    emergencyContact2Phone,
    emergencyContact2Relationship,
    authorizedForPickup2,
    learningCenterId,
    learningCenterName,

    learningCenterCharter,
    learningCenterAddress,
    generalRegistrationNotes,
    terminationNotes,
    orientationScheduled,
    orientationType,
    orientationTime,
    pg2FirstName,
    pg2LastName,
    pg2PrimaryPhoneType,
    pg2PrimaryEmail,
  },
  setShowFormEdit,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    formModal: {
      studentMatchModal,
      orientationModal,
      processRegistrationModal,
      specialProgramsModal,
      terminateEnrollmentModal,
      confirmModal,
      charter,
    },
    registrationStatusUpdate,
    setFormModal,
    getOrientationInformation,
    orientation_info,
    registration,
  } = adminRegistrationContext;

  const formDatas = {
    learningCenterId,
    learningCenterName,
    learningCenterCharter,
    learningCenterAddress,
    generalRegistrationNotes,
    createdAt,
    programs,
    programDescription,
    firstName,
    middleName,
    lastName,
    haveSuffix,
    suffix,
    gender,
    birthDate,
    age,
    birthState,
    birthCountry,
    gradeLevel,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    studentName,
    preferredpronouns,
    pgHighestLevelOfEducation,
    permissionParentContact,
    pgRelationshipToStudent,
    pgFirstName,
    pgLastName,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    pgPrimaryEmail,
    liveWithPg,
    livingStatus,
    street,
    city,
    state,
    zip,
    county,
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    mailingCountry,
    isStudentHispanicOrLatino,
    primaryRaceCategory,
    previousSchool,
    previousSchoolCity,
    previousSchoolState,
    primaryLanguage,
    firstLanguage,
    homeLanguage,
    languageSpokenByParentsToStudent,
    languageSpokenByAdultsAtHome,
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities,
    releaseAudioAndVideo,
    releasePermissionForSocialMedia,
    releaseUseStudentWork,
    releasePermissionToTextStudent,
    releasePermissionToTextPg,
    releaseAllowStudentAccessToGoogleAppsForEducation,
    beenExpelled,
    expelledFromWhichSchool,
    expelledWhatYear,
    beenSuspended,
    suspendedFromWhichSchool,
    suspendedWhatYear,
    onProbation,
    isParentOrExpecting,
    moreThanThreeUnexcusedAbsences,
    lateToSchoolMoreThanThreeTimes,
    orderedToAttendSchool,
    orderedToAttendWhichSchool,
    orderedToAttendWhatYear,
    retainedMoreThanOnce,
    retainedFromWhichSchool,
    retainedFromWhatYear,
    droppedOutOfSchool,
    droppedOutFromWhichSchool,
    droppedOutFromWhatYear,
    behindSemesterInCredits,
    outOfSchoolMoreThanFortyFiveDays,
    expelledMoreThanTwoSchoolsPastYear,
    fosterCare,
    youthExperiencingHomelessness,
    accessToComputerAtHome,
    accessToTheInternetAtHome,
    knownHealthConditions,
    asthma,
    beeStingAllergy,
    diabetes,
    epilepsy,
    heartCondition,
    seizures,
    nutAllergy,
    knownHearingConditions,
    wearsHearingAid,
    knownEyeCondition,
    glassesToBeWornAtAllTimes,
    wearsContactLenses,
    wearsGlasses,
    medications,
    otherHealthCondition,
    medicalInstructions,
    heathInsuranceCarrier,
    insuranceIdOrPolicyNumber,
    hospitalPreference,
    custodyIssueExists,
    custodyIssueNotes,
    legalRestrictionsForAnyParent,
    legalRestrictionsNotes,
    emergencyContact1FirstName,
    emergencyContact1LastName,
    emergencyContact1Phone,
    emergencyContact1Relationship,
    authorizedForPickup1,
    emergencyContact2FirstName,
    emergencyContact2LastName,
    emergencyContact2Phone,
    emergencyContact2Relationship,
    authorizedForPickup2,
    pg2RelationshipToStudent,
    pg2HighestLevelOfEducation,
    pg2FirstName,
    pg2LastName,
    pg2PrimaryPhoneType,
    pg2PrimaryPhone,
    pg2PrimaryEmail,
    liveWithPg2,
    registration,
    studentMatchModal,
    orientationModal,
    specialProgramsModal,
  };

   useEffect(() => {
       const loadBrands = async () => {
         await fetchBrands();
       };
   
       loadBrands();
     }, []);
  
     const brand_holston = brandDomains.brand_holston?.name;
     const brand_pbia = brandDomains.brand_pbia?.name;

  useEffect(() => {
    getOrientationInformation(learningCenterId);
  }, [learningCenterId]);

  const brandName = orientation_info.brandName;
  const formData = {
    studentMatchModal,
    orientationModal,
    specialProgramsModal,
    registration,
  };
  const registrationCompletedOrTerminated =
    status === "Enrollment Complete" || status === "Enrollment Terminated";

  if ((brandName && brandName.toLowerCase() === brand_holston) || (brandName && brandName === brand_pbia) ) {
    return (
      <>
        {confirmModal && (
          <ConfirmModal
            title="Reactivate Registration"
            body={`Are you sure you want to reactivate ${firstName}'s terminated registration?`}
            action={() =>
              registrationStatusUpdate(
                {
                  status: "Enrollment Submitted",
                  progressLevel: 1,
                  processingLevel: 0,
                },
                "POST",
                _id
              )
            }
            setModal={setFormModal}
            name="confirmModal"
            redirect="false"
            btnName="Reactivate"
            btnColor="l4l-red"
          />
        )}
        {terminateEnrollmentModal && <TerminateEnrollmentModal />}
        {specialProgramsModal && <AddSpecialProgramsModal />}
        {studentMatchModal && <StudentMatchModal type="POST" id={_id} />}
        {processRegistrationModal && (
          <ProcessRegistrationModal />
        )}
        {orientationModal && <OrientationModal type="POST" />}
        <div className="interest-form">
          <div className="top-bar">
            <div
              onClick={() => {
                typeof location.state === "undefined"
                  ? navigate(`/registration-forms`)
                  : navigate(location.state.from);
              }}
              className="left"
            >
              <FaIcons.FaArrowLeft className="menu-icon" />
              <span>Go Back</span>
            </div>
          </div>
          <ProgressLevelBar level={progressLevel} />
          <h1 className="top-title text-center">
            Enrollment Registration Form
          </h1>
          {!registrationCompletedOrTerminated && (
            <div className="edit-btn" onClick={() => setShowFormEdit(true)}>
              <p>Edit Form</p>
              <FaIcons.FaPencilAlt className="edit-icon" />
            </div>
          )}
          <div className="btns" style={{gap:"5px"}}>
            {processingLevel < 2 ? (
              <div
                onClick={() => setFormModal("processRegistrationModal", true)}
                className="btn btn-llac-dark-green"
              >
                Process Registration
              </div>
            ) : registrationCompletedOrTerminated ? (
              status === "Enrollment Terminated" ? (
                <div className="btns">
                  <div
                    className="btn btn-l4l-red"
                    onClick={() => setFormModal("confirmModal", true)}
                  >
                    Reactivate Registration
                  </div>
                </div>
              ) : null
            ) : (
              <div className="btns">
                <div
                  className="btn btn-llac-dark-grey"
                  onClick={() => setFormModal("orientationModal", true)}
                >
                  Reschedule Orientation
                </div>
                <div
                  className="btn btn-llac-light-green"
                  onClick={() => setFormModal("specialProgramsModal", true)}
                >
                  Add Special Programs
                </div>
                <div
                  className="btn btn-l4l-red"
                  onClick={() => setFormModal("terminateEnrollmentModal", true)}
                >
                  Terminate Registration
                </div>
              </div>
            )}
            <ExportPdfButton formData={formDatas} />
          </div>
          <div className="btns"></div>
          {/* <StudentMatchTable /> */}
          <div className="sub-forms">
            {/* Learning Center */}
            <div className="sub-form">
              <h3>Selected Learning Center</h3>
              <div className="sum-item">
                <h4>Site:</h4>
                <p>{learningCenterName}</p>
              </div>
              <div className="sum-item">
                <h4>Charter:</h4>
                <p>{learningCenterCharter}</p>
              </div>
              <div className="sum-item">
                <h4>Address:</h4>
                <p>{learningCenterAddress}</p>
              </div>
            </div>
            {/* General Registration Notes */}
            <div className="sub-form">
              <h3>Registration Notes</h3>
              <div className="sum-item">
                <h4>Registration Submitted :</h4>
                <p>{moment(createdAt).format("MM/DD/YYYY")}</p>
              </div>
              {orientationScheduled && (
                <div className="sum-item">
                  <h4>Orientation Date</h4>
                  <p>
                    {orientationType === "VIRTUAL"
                      ? "Virtual"
                      : orientationTime}
                  </p>
                </div>
              )}
              <div className="sum-item">
                <h4>General Notes :</h4>
                <p>{generalRegistrationNotes}</p>
              </div>
              {status === "Enrollment Terminated" && (
                <div className="sum-item">
                  <h4>Termination Notes</h4>
                  <p>{terminationNotes}</p>
                </div>
              )}
            </div>
            {/* Special Programs */}
            <div className="sub-form">
              <h3>Special Programs</h3>
              <div className="sum-item">
                <h4>Programs: </h4>
                {programs && programs.el && (
                  <>
                    {Object.keys(programs).map((item) => {
                      return (
                        <p>
                          {`${item.toUpperCase()}: ${
                            programs[item].unchecked
                              ? "Unchecked"
                              : programs[item].true
                              ? "True"
                              : "False"
                          }`}
                        </p>
                      );
                    })}
                  </>
                )}
              </div>

              <div className="sum-item">
                <h4>Special Programs Notes:</h4>
                <p>{programDescription}</p>
              </div>
            </div>
            {/* Student Information */}
            <div className="sub-form">
              <h3>Student Information</h3>
              <div className="sum-item">
                <h4>Student First Name:</h4>
                <p>{firstName}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Middle Initial:</h4>
                <p>{middleName}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Last Name:</h4>
                <p>{lastName}</p>
              </div>

              <div className="sum-item">
                <h4>{firstName} has Suffix:</h4>
                <p>
                  {haveSuffix === undefined ? "" : haveSuffix ? "Yes" : "No"}{" "}
                </p>
              </div>
              {suffix && (
                <ul>
                  <li>
                    <div className="sum-item-li">
                      <h4>{firstName}'s Suffix:</h4>
                      <p>{suffix}</p>
                    </div>
                  </li>
                </ul>
              )}

              <div className="sum-item">
                <h4>{firstName}'s Gender:</h4>
                <p>{gender}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Birth Date:</h4>
                <p>{moment(birthDate).utc().format("MM/DD/YYYY")}</p>
              </div>
              {!registerForIntercession && (
                <>
                  <div className="sum-item">
                    <h4>
                      {firstName === "" ? "the student" : firstName}'s Grade
                      Level:
                    </h4>
                    <p>{gradeLevel}</p>
                  </div>

                  {/* <div className="sum-item">
                    <h4>{firstName}'s Birth Country:</h4>
                    <p>{birthCountry}</p>
                  </div> */}
                </>
              )}
              <div className="sum-item">
                <h4>{firstName}'s Email:</h4>
                <p>{studentEmail}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Primary Phone Number:</h4>
                <p>{studentPrimaryPhone}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Primary Phone Type:</h4>
                <p>{studentPrimaryPhoneType}</p>
              </div>
            </div>
            {/* Student Prefrence*/}

            <div className="sub-form">
              <h3>Student Preference</h3>
              {!registerForIntercession && (
                <div className="sum-item">
                  <h4>
                    {" "}
                    {firstName === "" ? "the Student" : firstName}'s Preferred
                    Name:
                  </h4>
                  <p>{studentName}</p>
                </div>
              )}
              <div className="sum-item">
                <h4>
                  {" "}
                  {firstName === "" ? "The Student's" : firstName}'s Preferred
                  Pronouns:
                </h4>
                <p>{preferredpronouns}</p>
              </div>
            </div>

            <div className="sub-form">
              <h3>
                {pgRelationshipToStudent !== ""
                  ? `${pgRelationshipToStudent}'s `
                  : "Parent/Guardian "}
                Information
              </h3>
              {!registerForIntercession && (
                <div className="sum-item">
                  <h4>
                    {firstName}'s Parent/Guardian Highest Level of Education:
                  </h4>
                  <p>{pgHighestLevelOfEducation}</p>
                </div>
              )}
              {age >= 18 && (
                <div className="sum-item">
                  <h4>
                    Permission to Contact {firstName}'s Parent/Guardian about
                    School:
                  </h4>
                  <p>{permissionParentContact ? "Yes" : "No"}</p>
                </div>
              )}
              {(age < 18 || (age >= 18 && permissionParentContact)) && (
                <>
                  <div className="sum-item">
                    <h4>Parent/Guardian relationship to {firstName}:</h4>
                    <p>{pgRelationshipToStudent}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgRelationshipToStudent}'s First Name:</h4>
                    <p>{pgFirstName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgRelationshipToStudent}'s Last Name:</h4>
                    <p>{pgLastName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgFirstName}'s Email:</h4>
                    <p>{pgPrimaryEmail}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgFirstName}'s Primary Phone Number:</h4>
                    <p>{pgPrimaryPhone}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgFirstName}'s Primary Phone Type:</h4>
                    <p>{pgPrimaryPhoneType}</p>
                  </div>
                </>
              )}
            </div>
            {/* Parent Information  2*/}
            <div className="sub-form">
              <h3> Parent Information 2</h3>
              {!registerForIntercession && (
                <div className="sum-item">
                  <h4>
                    {" "}
                    {firstName === "" ? "the Student" : firstName}'s Parent
                    2/Guardian’s Highest Level of Education:
                  </h4>
                  <p>{pg2HighestLevelOfEducation}</p>
                </div>
              )}
              <div className="sum-item">
                <h4>
                  {" "}
                  Parent 2/Guardian’s Relationship to{" "}
                  {firstName === "" ? "the Student" : firstName}:{" "}
                </h4>
                <p>{pg2RelationshipToStudent}</p>
              </div>
              <div className="sum-item">
                <h4>
                  {firstName === "" ? "the Student" : firstName}'s Parent
                  2/Guardian’s First Name :
                </h4>
                <p>{pg2FirstName}</p>
              </div>

              <div className="sum-item">
                <h4>
                  {firstName === "" ? "the Student" : firstName}'s Parent
                  2/Guardian’s Last Name :
                </h4>
                <p>{pg2LastName}</p>
              </div>
              <div className="sum-item">
                <h4>
                  {" "}
                  {firstName === "" ? "the Student" : firstName}'s Parent
                  2/Guardian's Primary Phone Number :
                </h4>
                <p>{pg2PrimaryPhone}</p>
              </div>
              <div className="sum-item">
                <h4>
                  {firstName === "" ? "the Student" : firstName}'s Parent
                  2/Guardian's Primary Phone Type :
                </h4>
                <p>{pg2PrimaryPhoneType}</p>
              </div>
              <div className="sum-item">
                <h4>
                  {firstName === "" ? "the Student" : firstName}'s Parent
                  2/Guardian’s Email:
                </h4>
                <p>{pg2PrimaryEmail}</p>
              </div>
              <div className="sum-item">
                <h4>
                  {firstName === "" ? "the Student" : firstName} Lives With
                  Parent 2 :
                </h4>
                <p>
                  {liveWithPg2 === undefined ? "" : liveWithPg2 ? "Yes" : "No"}
                </p>
              </div>
            </div>

            {/* Physical Address */}
            <div className="sub-form">
              <h3>Physical Address</h3>
              <div className="sum-item">
                <h4>Street:</h4>
                <p>{street}</p>
              </div>
              <div className="sum-item">
                <h4>City:</h4>
                <p>{city}</p>
              </div>
              <div className="sum-item">
                <h4>State:</h4>
                <p>{state}</p>
              </div>
              <div className="sum-item">
                <h4>Zip:</h4>
                <p>{zip}</p>
              </div>
              <div className="sum-item">
                <h4>Country:</h4>
                <p>{county}</p>
              </div>
              <div className="sum-item">
                <h4>Same as Mailing Address: </h4>
                <p>{isMailingAddressTheSame ? "Yes" : "No"}</p>
              </div>
            </div>
            {/* Mailing Address */}
            {!isMailingAddressTheSame && (
              <div className="sub-form">
                <h3>Mailing Address</h3>
                <div className="sum-item">
                  <h4>Mailing Street:</h4>
                  <p>{mailingStreet}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing City:</h4>
                  <p>{mailingCity}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing State:</h4>
                  <p>{mailingState}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing Zip:</h4>
                  <p>{mailingZip}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing Country:</h4>
                  <p>{mailingCountry}</p>
                </div>
              </div>
            )}
            {!registerForIntercession && (
              <>
                {/* Ethnicity */}
                <div className="sub-form">
                  <h3>Ethnicity</h3>
                  <div className="sum-item">
                    <h4>{firstName} is Hispanic or Latino:</h4>
                    <p>
                      {isStudentHispanicOrLatino === undefined
                        ? ""
                        : isStudentHispanicOrLatino
                        ? "Yes"
                        : "No"}
                    </p>
                  </div>

                  <div className="sum-item">
                    <h4>{firstName}'s Primary Race Category:</h4>
                    <p>{primaryRaceCategory}</p>
                  </div>
                </div>
                {/* Previous School/Enrollment Information */}
                <div className="sub-form">
                  <h3>Previous School Information</h3>
                  <div className="sum-item">
                    <h4>{firstName}'s Previous School:</h4>
                    <p>{previousSchool}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName}'s Previous School City:</h4>
                    <p>{previousSchoolCity}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName}'s Previous School State:</h4>
                    <p>{previousSchoolState}</p>
                  </div>
                </div>
                {/* Primary Language */}
                <div className="sub-form">
                  <h3>Primary Language</h3>
                  <div className="sum-item">
                    <h4>{firstName}'s Primary language: </h4>
                    <p>{primaryLanguage}</p>
                  </div>
                </div>

                {/* Release Information */}
                <div className="sub-form">
                  <h3>Release Requests</h3>
                  <div className="sum-item">
                    <h4>
                      {" "}
                      Release: Permission to Text{" "}
                      {firstName === "" ? "Student" : firstName}:
                    </h4>
                    <p>{releaseAudioAndVideo ? "Yes" : "No"}</p>
                  </div>

                  <div className="sum-item">
                    <h4>Release: Permission to Text Parent/Guardians :</h4>
                    <p>{releasePermissionToTextPg ? "Yes" : "No"}</p>
                  </div>

                  <div className="sum-item">
                    <h4>
                      Release: Allow {firstName === "" ? " Student" : firstName}{" "}
                      Access to Google Apps for Education (GAE):
                    </h4>
                    <p>
                      {releaseAllowStudentAccessToGoogleAppsForEducation
                        ? "Yes"
                        : "No"}
                    </p>
                  </div>
                </div>

                <div className="sub-form">
                  <h3>Parent Custody Information </h3>
                  <div className="sum-item">
                    <h4>Custody Issue Exists for {firstName}:</h4>
                    <p>{custodyIssueExists ? "Yes" : "No"}</p>
                  </div>
                  {custodyIssueExists && (
                    <div className="sum-item">
                      <h4>Custody Issue Notes:</h4>
                      <p>{custodyIssueNotes}</p>
                    </div>
                  )}
                  <div className="sum-item">
                    <h4>
                      {" "}
                      Legal Restrictions for{" "}
                      {firstName === "" ? "the Student" : firstName}'s Parents:
                    </h4>
                    <p>{legalRestrictionsForAnyParent ? "Yes" : "No"}</p>
                  </div>
                  {legalRestrictionsForAnyParent && (
                    <div className="sum-item">
                      <h4>Legal Restrictions for any parent:</h4>
                      <p>{legalRestrictionsNotes}</p>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        {confirmModal && (
          <ConfirmModal
            title="Reactivate Registration"
            body={`Are you sure you want to reactivate ${firstName}'s terminated registration?`}
            action={() =>
              registrationStatusUpdate(
                {
                  status: "Enrollment Submitted",
                  progressLevel: 1,
                  processingLevel: 0,
                },
                "POST",
                _id
              )
            }
            setModal={setFormModal}
            name="confirmModal"
            redirect="false"
            btnName="Reactivate"
            btnColor="l4l-red"
          />
        )}
        {terminateEnrollmentModal && <TerminateEnrollmentModal />}
        {specialProgramsModal && <AddSpecialProgramsModal />}
        {studentMatchModal && <StudentMatchModal type="POST" id={_id} />}
        {processRegistrationModal && (
          <ProcessRegistrationModal />
        )}
        {orientationModal && <OrientationModal type="POST" />}
        <div className="interest-form">
          <div className="top-bar">
            <div
              onClick={() => {
                typeof location.state === "undefined"
                  ? navigate(`/registration-forms`)
                  : navigate(location.state.from);
              }}
              className="left"
            >
              <FaIcons.FaArrowLeft className="menu-icon" />
              <span>Go Back</span>
            </div>
          </div>
          <ProgressLevelBar level={progressLevel} />
          <h1 className="top-title text-center">
            Enrollment Registration Form
          </h1>
          {!registrationCompletedOrTerminated && (
            <div className="edit-btn" onClick={() => setShowFormEdit(true)}>
              <p>Edit Form</p>
              <FaIcons.FaPencilAlt className="edit-icon" />
            </div>
          )}
          <div className="btns" style={{gap:"5px"}}>
            {processingLevel < 2 ? (
              <div
                onClick={() => setFormModal("processRegistrationModal", true)}
                className="btn btn-llac-dark-green"
              >
                Process Registration
              </div>
            ) : registrationCompletedOrTerminated ? (
              status === "Enrollment Terminated" ? (
                <div className="btns">
                  <div
                    className="btn btn-l4l-red"
                    onClick={() => setFormModal("confirmModal", true)}
                  >
                    Reactivate Registration
                  </div>
                </div>
              ) : null
            ) : (
              <div className="btns">
                <div
                  className="btn btn-llac-dark-grey"
                  onClick={() => setFormModal("orientationModal", true)}
                >
                  Reschedule Orientation
                </div>
                <div
                  className="btn btn-llac-light-green"
                  onClick={() => setFormModal("specialProgramsModal", true)}
                >
                  Add Special Programs
                </div>
                <div
                  className="btn btn-l4l-red"
                  onClick={() => setFormModal("terminateEnrollmentModal", true)}
                >
                  Terminate Registration
                </div>
              </div>
            )}
            <ExportPdfButton formData={formDatas} />
          </div>
          <div className="btns"></div>
          {/* <StudentMatchTable /> */}
          <div className="sub-forms">
            {/* Learning Center */}
            <div className="sub-form">
              <h3>Selected Learning Center</h3>
              <div className="sum-item">
                <h4>Site:</h4>
                <p>{learningCenterName}</p>
              </div>
              <div className="sum-item">
                <h4>Charter:</h4>
                <p>{learningCenterCharter}</p>
              </div>
              <div className="sum-item">
                <h4>Address:</h4>
                <p>{learningCenterAddress}</p>
              </div>
            </div>
            {/* General Registration Notes */}
            <div className="sub-form">
              <h3>Registration Notes</h3>
              <div className="sum-item">
                <h4>Registration Submitted :</h4>
                <p>{moment(createdAt).format("MM/DD/YYYY")}</p>
              </div>
              {orientationScheduled && (
                <div className="sum-item">
                  <h4>Orientation Date</h4>
                  <p>
                    {orientationType === "VIRTUAL"
                      ? "Virtual"
                      : orientationTime}
                  </p>
                </div>
              )}
              <div className="sum-item">
                <h4>General Notes :</h4>
                <p>{generalRegistrationNotes}</p>
              </div>
              {status === "Enrollment Terminated" && (
                <div className="sum-item">
                  <h4>Termination Notes</h4>
                  <p>{terminationNotes}</p>
                </div>
              )}
            </div>
            {/* Special Programs */}
            <div className="sub-form">
              <h3>Special Programs</h3>
              <div className="sum-item">
                <h4>Programs: </h4>
                {programs && programs.el && (
                  <>
                    {Object.keys(programs).map((item) => {
                      return (
                        <p>
                          {`${item.toUpperCase()}: ${
                            programs[item].unchecked
                              ? "Unchecked"
                              : programs[item].true
                              ? "True"
                              : "False"
                          }`}
                        </p>
                      );
                    })}
                  </>
                )}
              </div>

              <div className="sum-item">
                <h4>Special Programs Notes :</h4>
                <p>{programDescription}</p>
              </div>
            </div>
            {/* Type of Enrollment */}

            {/* Student Information */}
            <div className="sub-form">
              <h3>Student Information</h3>
              <div className="sum-item">
                <h4>Students First Name:</h4>
                <p>{firstName}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Middle Initial:</h4>
                <p>{middleName}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Last Name:</h4>
                <p>{lastName}</p>
              </div>

              <div className="sum-item">
                <h4>{firstName} has Suffix:</h4>
                <p>
                  {haveSuffix === undefined ? "" : haveSuffix ? "Yes" : "No"}{" "}
                </p>
              </div>
              {suffix && (
                <ul>
                  <li>
                    <div className="sum-item-li">
                      <h4>{firstName}'s Suffix:</h4>
                      <p>{suffix}</p>
                    </div>
                  </li>
                </ul>
              )}
              <div className="sum-item">
                <h4>{firstName}'s Gender:</h4>
                <p>{gender}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Birth Date:</h4>
                <p>{moment(birthDate).utc().format("MM/DD/YYYY")}</p>
              </div>

              <div className="sum-item">
                <h4>
                  {firstName === "" ? "the student" : firstName}'s Birth State:
                </h4>
                <p>{birthState}</p>
              </div>
              <div className="sum-item">
                <h4>
                  {firstName === "" ? "the student" : firstName}'s Birth
                  Country:
                </h4>
                <p>{birthCountry}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Email:</h4>
                <p>{studentEmail}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Primary Phone Number:</h4>
                <p>{studentPrimaryPhone}</p>
              </div>
              <div className="sum-item">
                <h4>{firstName}'s Primary Phone Type:</h4>
                <p>{studentPrimaryPhoneType}</p>
              </div>
            </div>
            {/* Student Prefrence*/}

            <div className="sub-form">
              <h3>
                {pgRelationshipToStudent !== ""
                  ? `${pgRelationshipToStudent}'s `
                  : "Parent/Guardian "}
                Information
              </h3>
              {!registerForIntercession && (
                <div className="sum-item">
                  <h4>
                    {firstName}'s Parent/Guardian Highest Level of Education:
                  </h4>
                  <p>{pgHighestLevelOfEducation}</p>
                </div>
              )}
              {age >= 18 && (
                <div className="sum-item">
                  <h4>
                    Permission to contact {firstName}'s Parent/Guardian about
                    School:
                  </h4>
                  <p>{permissionParentContact ? "Yes" : "No"}</p>
                </div>
              )}
              {(age < 18 || (age >= 18 && permissionParentContact)) && (
                <>
                  <div className="sum-item">
                    <h4>Parent/Guardian relationship to {firstName}:</h4>
                    <p>{pgRelationshipToStudent}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgRelationshipToStudent}'s First Name:</h4>
                    <p>{pgFirstName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgRelationshipToStudent}'s Last Name:</h4>
                    <p>{pgLastName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgFirstName}'s Email:</h4>
                    <p>{pgPrimaryEmail}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgFirstName}'s Primary Phone Number:</h4>
                    <p>{pgPrimaryPhone}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{pgFirstName}'s Primary Phone Type:</h4>
                    <p>{pgPrimaryPhoneType}</p>
                  </div>
                </>
              )}
            </div>

            {/* Physical Address */}
            <div className="sub-form">
              <h3>Physical Address</h3>
              {!registerForIntercession && (
                <div className="sum-item">
                  <h4>{firstName} lives with Parent/Guardian:</h4>
                  <p>{liveWithPg ? "Yes" : "No"}</p>
                </div>
              )}
              <div className="sum-item">
                <h4>{firstName}'s Living Status:</h4>
                <p>{livingStatus}</p>
              </div>
              <div className="sum-item">
                <h4>Street:</h4>
                <p>{street}</p>
              </div>
              <div className="sum-item">
                <h4>City:</h4>
                <p>{city}</p>
              </div>
              <div className="sum-item">
                <h4>State:</h4>
                <p>{state}</p>
              </div>
              <div className="sum-item">
                <h4>Zip:</h4>
                <p>{zip}</p>
              </div>
              <div className="sum-item">
                <h4>Country:</h4>
                <p>{county}</p>
              </div>
              <div className="sum-item">
                <h4>Same as Mailing Address: </h4>
                <p>{isMailingAddressTheSame ? "Yes" : "No"}</p>
              </div>
            </div>
            {/* Mailing Address */}
            {!isMailingAddressTheSame && (
              <div className="sub-form">
                <h3>Mailing Address</h3>
                <div className="sum-item">
                  <h4>Mailing Street:</h4>
                  <p>{mailingStreet}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing City:</h4>
                  <p>{mailingCity}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing State:</h4>
                  <p>{mailingState}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing Zip:</h4>
                  <p>{mailingZip}</p>
                </div>
                <div className="sum-item">
                  <h4>Mailing Country:</h4>
                  <p>{mailingCountry}</p>
                </div>
              </div>
            )}
            {!registerForIntercession && (
              <>
                {/* Ethnicity */}
                <div className="sub-form">
                  <h3>Ethnicity</h3>
                  <div className="sum-item">
                    <h4>{firstName} is Hispanic or Latino:</h4>
                    <p>{isStudentHispanicOrLatino ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName}'s Primary Race Category:</h4>
                    <p>{primaryRaceCategory}</p>
                  </div>
                </div>
                {/* Previous School/Enrollment Information */}
                <div className="sub-form">
                  <h3>Previous School Information</h3>
                  <div className="sum-item">
                    <h4>{firstName}'s Previous School:</h4>
                    <p>{previousSchool}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName}'s Previous School City:</h4>
                    <p>{previousSchoolCity}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName}'s Previous School State:</h4>
                    <p>{previousSchoolState}</p>
                  </div>
                </div>
                {/* Primary Language */}
                <div className="sub-form">
                  <h3>Primary Language</h3>
                  <div className="sum-item">
                    <h4>{firstName}'s Primary language: </h4>
                    <p>{primaryLanguage}</p>
                  </div>
                </div>
                {/* Home Language Survey */}
                <div className="sub-form">
                  <h3>Home Language Survey</h3>
                  <div className="sum-item">
                    <h4>{firstName}'s First Language:</h4>
                    <p>{firstLanguage}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Language spoken at {firstName}'s Home:</h4>
                    <p>{homeLanguage}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Language Spoken by Parent/Guardian to {firstName}:</h4>
                    <p>{languageSpokenByParentsToStudent}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Language Spoken by Adults at {firstName} Home:</h4>
                    <p>{languageSpokenByAdultsAtHome}</p>
                  </div>
                </div>
                {/* Migrant Information */}
                <div className="sub-form">
                  <h3>Migrant Education</h3>
                  <div className="sum-item">
                    <h4>
                      {firstName}'s Parent/Guardian is Employed in one or more
                      Agricultural or Fishing Activities on a Seasonal or Other
                      Temporary Basis:
                    </h4>
                    <p>
                      {isPgEmployedInOneOrMoreAgriculturalOrFishingActivities
                        ? "Yes"
                        : "No"}
                    </p>
                  </div>
                </div>
                {/* Release Information */}
                <div className="sub-form">
                  <h3>Release Requests</h3>
                  <div className="sum-item">
                    <h4>Release: Audio and Video:</h4>
                    <p>{releaseAudioAndVideo ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      Release: Permission for the School to use Student
                      Pictures, Audio, Video, and Student Work on Social Media:
                    </h4>
                    <p>{releasePermissionForSocialMedia ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Release: Use Student Work:</h4>
                    <p>{releaseUseStudentWork ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Release: Permission to Text {firstName}:</h4>
                    <p>{releasePermissionToTextStudent ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Release: Permission to Text Parent/Guardians:</h4>
                    <p>{releasePermissionToTextPg ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      Release: Allow {firstName} access to Google Apps for
                      Education (GAE) :
                    </h4>
                    <p>
                      {releaseAllowStudentAccessToGoogleAppsForEducation
                        ? "Yes"
                        : "No"}
                    </p>
                  </div>
                </div>
                {/* Dass Information */}
                <div className="sub-form">
                  <h3>DASS Information</h3>
                  <div className="sum-item">
                    <h4>
                      {firstName} has Ever Been Expelled From Any School for Any
                      Reason:
                    </h4>
                    <p>{beenExpelled ? "Yes" : "No"}</p>
                  </div>
                  {beenExpelled && (
                    <ul>
                      <li>
                        <div className="sum-item-li">
                          <h4>School:</h4>
                          <p>{expelledFromWhichSchool}</p>
                        </div>
                      </li>
                      <li>
                        <div className="sum-item-li">
                          <h4>Year:</h4>
                          <p>{expelledWhatYear}</p>
                        </div>
                      </li>
                    </ul>
                  )}
                  <div className="sum-item">
                    <h4>
                      {firstName} has Ever Been Suspended for More Than 10 Days
                      in Any School Year:
                    </h4>
                    <p>{beenSuspended ? "Yes" : "No"}</p>
                  </div>
                  {beenSuspended && (
                    <ul>
                      <li>
                        <div className="sum-item-li">
                          <h4>School:</h4>
                          <p>{suspendedFromWhichSchool}</p>
                        </div>
                      </li>
                      <li>
                        <div className="sum-item-li">
                          <h4>Year:</h4>
                          <p>{suspendedWhatYear}</p>
                        </div>
                      </li>
                    </ul>
                  )}
                  <div className="sum-item">
                    <h4>{firstName} is on Probation:</h4>
                    <p>{onProbation ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      {firstName} a Parent (Mother or Father) or Expecting Child
                      Soon:
                    </h4>
                    <p>{isParentOrExpecting ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      {firstName} has more than 3 Unexcused Absences in a School
                      Year
                    </h4>
                    <p>{moreThanThreeUnexcusedAbsences ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      {firstName} has been 30 Minutes Late to School 3 or More
                      Times in a School Year:
                    </h4>
                    <p>{lateToSchoolMoreThanThreeTimes ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      {firstName} has ever been Ordered To Attend School by a
                      Review Board or Probation Officer
                    </h4>
                    <p>{orderedToAttendSchool ? "Yes" : "No"}</p>
                  </div>
                  {orderedToAttendSchool && (
                    <ul>
                      <li>
                        <div className="sum-item-li">
                          <h4>School:</h4>
                          <p>{orderedToAttendWhichSchool}</p>
                        </div>
                      </li>
                      <li>
                        <div className="sum-item-li">
                          <h4>Year:</h4>
                          <p>{orderedToAttendWhatYear}</p>
                        </div>
                      </li>
                    </ul>
                  )}
                  <div className="sum-item">
                    <h4>
                      {firstName} has Retained (Held Back) More Than Once in
                      Grades K-8:
                    </h4>
                    <p>{retainedMoreThanOnce ? "Yes" : "No"}</p>
                  </div>
                  {retainedMoreThanOnce && (
                    <ul>
                      <li>
                        <div className="sum-item-li">
                          <h4>School:</h4>
                          <p>{retainedFromWhichSchool}</p>
                        </div>
                      </li>
                      <li>
                        <div className="sum-item-li">
                          <h4>Year:</h4>
                          <p>{retainedFromWhatYear}</p>
                        </div>
                      </li>
                    </ul>
                  )}
                  <div className="sum-item">
                    <h4>{firstName} Ever Dropped Out of School:</h4>
                    <p>{droppedOutOfSchool ? "Yes" : "No"}</p>
                  </div>
                  {droppedOutOfSchool && (
                    <ul>
                      <li>
                        <div className="sum-item-li">
                          <h4>School:</h4>
                          <p>{droppedOutFromWhichSchool}</p>
                        </div>
                      </li>
                      <li>
                        <div className="sum-item-li">
                          <h4>Year:</h4>
                          <p>{droppedOutFromWhatYear}</p>
                        </div>
                      </li>
                    </ul>
                  )}
                  <div className="sum-item">
                    <h4>
                      {" "}
                      {firstName} is Behind a Semester or More in Credits
                    </h4>
                    <p>{behindSemesterInCredits ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      {firstName} have been out of School for 45 Days or More
                      Not Including Summer, Holiday Break,
                      <br />
                      Off-Track or Any Other Days When a School is Closed:
                    </h4>
                    <p>{outOfSchoolMoreThanFortyFiveDays ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>
                      {firstName} have been Enrolled in More Than 2 Schools
                      During the Past Academic Year or Have Changed Schools More
                      Than Two Times Since <br /> entering High School:
                    </h4>
                    <p>{expelledMoreThanTwoSchoolsPastYear ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName} is in Foster Care:</h4>
                    <p>{fosterCare ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4> {firstName} is a Youth Experiencing Homelessness</h4>
                    <p>{youthExperiencingHomelessness ? "Yes" : "No"}</p>
                  </div>
                </div>
                {/* Home Survey */}
                <div className="sub-form">
                  <h3>Home Survey</h3>
                  <div className="sum-item">
                    <h4> {firstName} has Access to Computer at Home:</h4>
                    <p>{accessToComputerAtHome ? "Yes" : "No"}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName} has Access to the Internet at Home:</h4>
                    <p>{accessToTheInternetAtHome ? "Yes" : "No"}</p>
                  </div>
                </div>
                {/* Health Conditions */}
                <div className="sub-form">
                  <h3>Health Conditions</h3>
                  <div className="sum-item">
                    <h4>{firstName} has any known Health Conditions:</h4>
                    <p>{knownHealthConditions ? "Yes" : "No"}</p>
                  </div>
                  {knownHealthConditions && (
                    <ul>
                      <li>
                        <div className="sum-item-li">
                          <h4>Asthma</h4>
                          <p>{asthma ? "Yes" : "No"}</p>
                        </div>
                      </li>

                      <li>
                        <div className="sum-item-li">
                          <h4>Bee Sting Allergy</h4>
                          <p>{beeStingAllergy ? "Yes" : "No"}</p>
                        </div>
                      </li>

                      <li>
                        <div className="sum-item-li">
                          <h4>Diabetes</h4>
                          <p>{diabetes ? "Yes" : "No"}</p>
                        </div>
                      </li>

                      <li>
                        <div className="sum-item-li">
                          <h4>Epilepsy</h4>
                          <p>{epilepsy ? "Yes" : "No"}</p>
                        </div>
                      </li>

                      <li>
                        {" "}
                        <div className="sum-item-li">
                          <h4>Heart Condition</h4>
                          <p>{heartCondition ? "Yes" : "No"}</p>
                        </div>
                      </li>

                      <li>
                        <div className="sum-item-li">
                          <h4>Seizures</h4>
                          <p>{seizures ? "Yes" : "No"}</p>
                        </div>
                      </li>

                      <li>
                        <div className="sum-item-li">
                          <h4>Nut Allergy</h4>
                          <p>{nutAllergy ? "Yes" : "No"}</p>
                        </div>
                      </li>
                    </ul>
                  )}

                  {/* Conditions which affect hearing */}
                  <div className="sum-item">
                    <h4> {firstName} has any known Hearing Problems:</h4>
                    <p>{knownHearingConditions ? "Yes" : "No"}</p>
                  </div>
                  {knownHearingConditions && (
                    <div className="sum-item">
                      <h4>{firstName} wear a Hearing Aid:</h4>
                      <p>{wearsHearingAid ? "Yes" : "No"}</p>
                    </div>
                  )}
                  {/* Conditions Which Affect Vision */}
                  <div className="sum-item">
                    <h4>{firstName} has any known Eye Conditions:</h4>
                    <p>{knownEyeCondition ? "Yes" : "No"}</p>
                  </div>
                  {/* {knownEyeCondition && (
                        <ul>
                          <li>
                            <div className="sum-item-li">
                              <h4>
                                {firstName} need glasses to be worn at all times:
                              </h4>
                              <p>{glassesToBeWornAtAllTimes ? "Yes" : "No"}</p>
                            </div>
                          </li>
      
                          <li>
                            <div className="sum-item-li">
                              <h4>Does {firstName} Wear Contact Lenses</h4>
                              <p>{wearsContactLenses ? "Yes" : "No"}</p>
                            </div>
                          </li>
      
                          <li>
                            <div className="sum-item-li">
                              <h4>Does {firstName} Wear Glasses</h4>
                              <p>{wearsGlasses ? "Yes" : "No"}</p>
                            </div>
                          </li>
                        </ul>
                      )} */}
                  {/* Health Information */}

                  <div className="sum-item">
                    <h4>{firstName} has any Medications:</h4>
                    <p>{medications}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName} has any Other Health Conditions:</h4>
                    <p>{otherHealthCondition}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName} has any Medical Instructions:</h4>
                    <p>{medicalInstructions}</p>
                  </div>
                  {/* Insurance */}
                  <div className="sum-item">
                    <h4>{firstName}'s Heath Insurance Carrier:</h4>
                    <p>{heathInsuranceCarrier}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName}'s Insurance ID or Policy #:</h4>
                    <p>{insuranceIdOrPolicyNumber}</p>
                  </div>
                  <div className="sum-item">
                    <h4>{firstName}'s Hospital Preference:</h4>
                    <p>{hospitalPreference}</p>
                  </div>
                </div>
                <div className="sub-form">
                  <h3>Parent Custody Information </h3>
                  <div className="sum-item">
                    <h4>Custody Issue Exists for {firstName}:</h4>
                    <p>{custodyIssueExists ? "Yes" : "No"}</p>
                  </div>
                  {custodyIssueExists && (
                    <div className="sum-item">
                      <h4>Custody Issue Notes:</h4>
                      <p>{custodyIssueNotes}</p>
                    </div>
                  )}
                  <div className="sum-item">
                    <h4>
                      {" "}
                      Legal Restrictions for{" "}
                      {firstName === "" ? "the Student" : firstName}'s Parents:
                    </h4>
                    <p>{legalRestrictionsForAnyParent ? "Yes" : "No"}</p>
                  </div>
                  {legalRestrictionsForAnyParent && (
                    <div className="sum-item">
                      <h4>Legal Restrictions for any parent:</h4>
                      <p>{legalRestrictionsNotes}</p>
                    </div>
                  )}
                </div>

                <div className="sub-form">
                  <h3>Emergency Contacts</h3>
                  {/* Contact 1 */}
                  <div className="sum-item">
                    <h4>Emergency Contact 1 First Name:</h4>
                    <p>{emergencyContact1FirstName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Emergency Contact 1 Last Name:</h4>
                    <p>{emergencyContact1LastName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Emergency Contact 1 Phone Number:</h4>
                    <p>{emergencyContact1Phone}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Emergency Contact 1 Relationship:</h4>
                    <p>{emergencyContact1Relationship}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Authorized for Pickup:</h4>
                    <p>{authorizedForPickup1 ? "Yes" : "No"}</p>
                  </div>
                  {/* Contact 2 */}
                  <div className="sum-item">
                    <h4>Emergency Contact 2 First Name:</h4>
                    <p>{emergencyContact2FirstName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Emergency Contact 2 Last Name:</h4>
                    <p>{emergencyContact2LastName}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Emergency Contact 2 Phone Number:</h4>
                    <p>{emergencyContact2Phone}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Emergency Contact 2 Relationship:</h4>
                    <p>{emergencyContact2Relationship}</p>
                  </div>
                  <div className="sum-item">
                    <h4>Authorized for Pickup:</h4>
                    <p>{authorizedForPickup2 ? "Yes" : "No"}</p>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* <div className="btns">
                <div
                  onClick={() => {
                    setFormModal("confirmModal", true);
                  }}
                  className="btn btn-l4l-red btn-outline"
                >
                  Delete Entry
                </div>
              </div> */}
        </div>
      </>
    );
  }
};

export default RegistrationForm;
